<template>
  <div>
    <div class="panel animated fadeInRightBig">
      <div class="panel-heading">
        <div class="panel-title">
          <span class="title">
            <b>Editar Administrador</b>

            <i
              class="fa fa-user-circle"
              style="float: right; margin-top: 6px; font-size: 21px"
            ></i>

            <hr />
          </span>
        </div>
      </div>

      <div class="panel-body">
        <div class="row">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-4">
                <label for="name"
                  ><span class="required">*</span> Nome do Usuário</label
                >
                <input
                  type="text"
                  class="form-control"
                  name="name"
                  v-model="admin.name"
                  id="name"
                  placeholder="Seu nome aqui"
                />
              </div>
              <div class="col-md-4">
                <label for="email"
                  ><span class="required">*</span> E-mail</label
                >
                <input
                  type="email"
                  class="form-control"
                  name="name"
                  v-model="admin.email"
                  id="email"
                  placeholder="example@example.com.br"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3">
                <label for="password"
                  ><span class="required">*</span> Senha</label
                >
                <input
                  type="password"
                  name="password"
                  class="form-control"
                  id="password"
                  placeholder="***********"
                  v-model="admin.password"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <form id="form" v-if="admin">
        <div class="ibox-footer">
          <div class="pull-right">
            <router-link to="/admins" class="btn btn-info">
              <i class="fa fa-arrow-left"></i> Voltar
            </router-link>
            <a class="btn btn-success" @click="save">
              Salvar <i class="fa fa-save"></i>
            </a>
          </div>
          <p><span class="required">*</span> Campos Obrigatórios</p>
          <div class="clearfix"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      previewImage: null,
      admin: {
        name: "",
        email: "",
        password: "",
      },
      errors: undefined,
    };
  },
  computed: {},
  methods: {
    save: function () {
      const id = this.$route.params.id;
      const api = this.$store.state.api + "admins/" + id;
      const self = this;

      let form = new FormData();
      let photo = document.getElementById("photo");

      form.append("name", self.admin.name);
      form.append("email", self.admin.email);

      if (self.admin.password) {
        form.append("password", self.admin.password);
      }
      form.append("_method", "PUT");

      self.$http
        .post(api, form)
        .then((response) => {
          self.$message("Sucesso", `Administrador atualizado com sucesso`, "success");
          this.$router.push("/admins");
        })
        .catch((error) => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function (key, value) {
              html += "<li>" + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
    getAdmin: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "admins/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.admin = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    this.getAdmin();
  },
};
</script>
<style>
.mt-2 {
  margin-top: 1rem !important;
}
.btn-addimg {
  background-color: white;
  font-size: 12px;
  border: solid 2px;
  width: 160px;
  text-align: center;
}
.addimg {
  width: 160px;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Edit.vue